















import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IBackgroundImage } from "@/@types/styles/background-image";
import { IHeightStyle } from "@/@types/styles/height";

@Component({})
export default class HotelInfoDemo extends Vue {
  @Prop({ type: String, default: "" }) name!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) background!: string;
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) language!: string;

  @Inject("backgroundFolder") readonly backgroundFolder!: string;
  @Inject("imageFolder") readonly imageFolder!: string;

  show = false;

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  get getBacground(): IBackgroundImage {
    return {
      backgroundImage: `url(${this.$getWebImage(
        this.background,
        `${this.backgroundFolder}/origin`
      )})`,
    };
  }

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  mounted(): void {
    this.calculateHeight();
  }
}
